/* eslint-disable @typescript-eslint/no-explicit-any */
import { call, takeLatest, put } from "redux-saga/effects";
import { newRequest } from "../../../api/token";
import get from "lodash/get";
import {
  SET_GQL_AGENT_CONTACT_DETAILS,
  SET_GQL_AUTH_LOGIN,
  SET_GQL_REFRESH_TOKEN,
  SET_GQL_GST_STATE_CODE,
  SET_GQL_COUNTRIES_CODE,
  SET_GQL_CITIES_CODE,
  SET_GQL_CURRENCY_LIST,
  SET_AUTH_FORGOTPASSWORD,
  SET_AUTH_RESETPASSWORD,
  SET_AUTH_RESETPASSWORDLS,
  GENERATE_ACCESS_TOKEN_DETAILS,
  SET_AUTH_RESENDOTP,
  SET_AUTH_VERIFYOTP,
  SET_AUTH_CHANGEPASSWORD,
} from "../../actionTypes/loginActionTypes";
import {
  GQLAgentContactDetailsAction,
  GqlGstStateCodeAction,
  LoginGQLAgentAction,
  LoginGQLRefreshToken,
  GqlCountriesCodeAction,
  GqlCitiesCodeAction,
  GqlCurrencyListAction,
  setForgotPasswordAction,
  setResetPasswordAction,
  setResetPasswordLSAction,
  generateAccessTokenAction,
  setResendOTPAction,
  setVerifyOTPAction,
  setChangePasswordAction,
} from "../../actions/loginActions";
import { isGlobalApolloError, logout } from "../../../utils/helpers/auth";
import {
  AGENT_CONTACT_DETAILS,
  AGENT_LOGIN,
  AGENT_Refresh_Token,
  GST_STATE_CODE,
  COUNTRIES_CODE,
  STATES_CODE,
  CURRENCY_LIST,
  AGENT_FORGOT_PASSWORD,
  AGENT_RESET_PASSWORD,
  AGENT_RESET_PASSWORD_LINK_STATUS,
  GENERATE_ACCESS_TOKEN_QUERY,
  RESEND_OTP,
  VERIFY_OTP,
  CHANGE_PASSWORD,
} from "../../gqlQueries/authQuery";
import { POST_LOGIN } from "../../gqlQueries/Dashboard/grnQuery";
import DOMPurify from "dompurify";
import { getNotificationMessage } from "../../actions/localStorageActions";
import { UIMessage } from "../../../components/UI/UIMessage";


function* setLoginGQL(action: any): any {
  try {
    // user login
    const loginData = yield call(newRequest, {
      callMethod: "mutation",
      callType: "apollo",
      dataQuery: AGENT_LOGIN,
      data: { request: action?.payload?.request },
    });
    if (
      loginData?.data?.userLogin?.successTypeCode?.toLowerCase() == "success" &&
      !loginData?.data?.userLogin?.responseData?.isfirsttimeuser &&
      !loginData?.data?.userLogin?.responseData?.isOtpRequired
    ) {
      const customHeaders = {
        headers: {
          Authorization: `Bearer ${loginData?.data?.userLogin?.responseData?.token}`,
          "Wrapper-Token": `Bearer ${loginData?.data?.userLogin?.responseData?.token}`,
        },
      };

      const grnLogin = yield call(newRequest, {
        callMethod: "mutation",
        callType: "apollo",
        data: customHeaders,
        clientType: "BE",
        dataQuery: POST_LOGIN,
      });
      action?.payload?.setLoading?.(false);
      if (
        grnLogin?.data?.login?.responseData?.status?.toLowerCase() == "success"
      ) {
        yield put(LoginGQLAgentAction.FULLFILLED(loginData));
      } else {
        yield* showError(grnLogin, null, null);
      }
    } else if (
      loginData?.data?.userLogin?.responseData?.isfirsttimeuser ||
      loginData?.data?.userLogin?.responseData?.isOtpRequired
    ) {
      yield put(LoginGQLAgentAction.FULLFILLED(loginData));
    } else {
      // yield* showError(loginData, "refresh", action);
      yield put(LoginGQLAgentAction.REJECTED(loginData));
    }
  } catch (error: any) {
    action?.payload?.setLoading?.(false);
    yield* showError("failed", "refresh", action);
    const errorResponse = {
      error: true,
      message: get(error, "data.error.error", "Failed to log in"),
    };
    yield put(LoginGQLAgentAction.REJECTED(errorResponse?.message));
  }
}

function* setRefreshTokenGQL(action: any): any {
  try {
    const refreshData = yield call(newRequest, {
      callMethod: "mutation",
      callType: "apollo",
      dataQuery: AGENT_Refresh_Token,
      data: action?.payload?.data,
    });
    if (
      refreshData?.data?.refreshToken?.successTypeCode?.toLowerCase() ==
      "success"
    ) {
      yield put(LoginGQLRefreshToken.FULLFILLED(refreshData));
      //window.location.reload();
    } else {
      yield put(LoginGQLRefreshToken.REJECTED(refreshData));
    }
  } catch (error: any) {
    const errorResponse = {
      error: true,
      message: get(error, "data.error.error", "Failed to log in"),
    };
    yield put(LoginGQLRefreshToken.REJECTED(errorResponse?.message));
  }
}

function* showError(response: any, type: any, action: any) {
  let messageInfo = "Invalid Username and Password";
  if (response?.data?.userLogin?.successTypeCode?.toLowerCase() == "failed") {
    messageInfo = response?.data?.userLogin?.messageDescription;
  } else if (
    response?.data?.login?.responseData?.status?.toLowerCase() !== "success"
  ) {
    messageInfo = response?.data?.login?.responseData?.data?.message;
  } else if (response?.toLowerCase() === "failed") {
    messageInfo = "Failed to Log in, Please check Network connection";
  }
  const message = {
    messageText: messageInfo || "Failed to Log in, Please check Network connection or try again later",
    closeIcon: true,
  };
  yield UIMessage(message);
  if (action?.payload?.setLoading) {
    action?.payload?.setLoading(false);
  }
  if (type == "login" && action.logincallback) {
    action.logincallback(response);
  }
  if (type == "grnlogin" && action.usercallback) {
    action.usercallback(response);
  }
}

function* mutationAgentContactDetails(action: any): any {
  try {
    const graphqlMutateData = yield call(newRequest, {
      callType: "apollo",
      callMethod: "mutation",
      dataQuery: AGENT_CONTACT_DETAILS,
      data: action?.payload,
    });

    yield put(GQLAgentContactDetailsAction.FULLFILLED(graphqlMutateData));
  } catch (error) {
    if (isGlobalApolloError(error)) return;
    const message = {
      isOpen: true,
      mainHeader: "Failed to connect",
      subHeader: "",
      message: "Please check Network connection",
      subReq: false,
    };
    yield put(getNotificationMessage(message));
    yield put(GQLAgentContactDetailsAction.REJECTED(String(error)));
  }
}

function* queryGstStateCode(action: any): any {
  try {
    const GSTData = yield call(newRequest, {
      callType: "apollo",
      callMethod: "query",
      dataQuery: GST_STATE_CODE,
      data: action?.payload,
      clientType: "MO",
      // data: agentPayload
    });
    yield put(GqlGstStateCodeAction.FULLFILLED(GSTData));
  } catch (error) {
    if (isGlobalApolloError(error)) return;
    const message = {
      isOpen: true,
      mainHeader: "Failed to connect",
      subHeader: "",
      message: "Please check Network connection",
      subReq: false,
    };
    yield put(getNotificationMessage(message));
    yield put(GqlGstStateCodeAction.REJECTED(String(error)));
  }
}

function* forgotPassword(action: any): any {
  try {
    const forgotPasswordData = yield call(newRequest, {
      callType: "apollo",
      callMethod: "mutation",
      dataQuery: AGENT_FORGOT_PASSWORD,
      data: action?.payload,
    });
    yield put(setForgotPasswordAction.FULLFILLED(forgotPasswordData));
  } catch (error) {
    const message = {
      isOpen: true,
      mainHeader: "Failed to connect",
      subHeader: "",
      message: "Please check Network connection",
      subReq: false,
    };
    yield put(getNotificationMessage(message));
    yield put(setForgotPasswordAction.REJECTED(String(error)));
  }
}

function* resetPassword(action: any): any {
  try {
    const resetPasswordData = yield call(newRequest, {
      callType: "apollo",
      callMethod: "mutation",
      dataQuery: AGENT_RESET_PASSWORD,
      data: action?.payload,
    });
    yield put(setResetPasswordAction.FULLFILLED(resetPasswordData));
  } catch (error) {
    const basename = process.env.BASE_NAME;
    const message = {
      isOpen: true,
      mainHeader: "Failed to connect",
      subHeader: "",
      message: "Please check Network connection",
      subReq: false,
      callback: () => (window.location.href = `${basename}home`),
    };
    yield put(getNotificationMessage(message));
    yield put(setResetPasswordAction.REJECTED(String(error)));
  }
}

function* resetPasswordLinkStatus(action: any): any {
  try {
    const resetPasswordLSData = yield call(newRequest, {
      callType: "apollo",
      callMethod: "mutation",
      dataQuery: AGENT_RESET_PASSWORD_LINK_STATUS,
      data: action?.payload,
    });
    yield put(setResetPasswordLSAction.FULLFILLED(resetPasswordLSData));
  } catch (error) {
    const basename = process.env.BASE_NAME;
    const message = {
      isOpen: true,
      mainHeader: "Failed to connect",
      subHeader: "",
      message: "Please check Network connection",
      subReq: false,
      callback: () => (window.location.href = `${basename}home`),
    };
    yield put(getNotificationMessage(message));
    yield put(setResetPasswordLSAction.REJECTED(String(error)));
  }
}

function* resendOTP(action: any): any {
  try {
    const resendOTPData = yield call(newRequest, {
      callType: "apollo",
      callMethod: "mutation",
      dataQuery: RESEND_OTP,
      data: action?.payload,
    });
    yield put(setResendOTPAction.FULLFILLED(resendOTPData));
  } catch (error) {
    const basename = process.env.BASE_NAME;
    const message = {
      isOpen: true,
      mainHeader: "Failed to connect",
      subHeader: "",
      message: "Please check Network connection",
      subReq: false,
      callback: () => (window.location.href = `${basename}home`),
    };
    yield put(getNotificationMessage(message));
    yield put(setResendOTPAction.REJECTED(String(error)));
  }
}

function* verifyOTP(action: any): any {
  try {
    const verifyOTPData = yield call(newRequest, {
      callType: "apollo",
      callMethod: "mutation",
      dataQuery: VERIFY_OTP,
      data: action?.payload,
    });
    if (verifyOTPData?.data?.verifyOTP?.successTypeCode === "SUCCESS") {
      const customHeaders = {
        headers: {
          Authorization: `Bearer ${verifyOTPData?.data?.verifyOTP?.responseData?.token}`,
          "Wrapper-Token": `Bearer ${verifyOTPData?.data?.verifyOTP?.responseData?.token}`,
        },
      };

      const grnLogin = yield call(newRequest, {
        callMethod: "mutation",
        callType: "apollo",
        data: customHeaders,
        clientType: "BE",
        dataQuery: POST_LOGIN,
      });

      if (
        grnLogin?.data?.login?.responseData?.status?.toLowerCase() == "success"
      ) {
        yield put(LoginGQLAgentAction.FULLFILLED(verifyOTPData));
      } else {
        yield* showError(grnLogin, null, null);
      }
    } else {
      yield put(setVerifyOTPAction.FULLFILLED(verifyOTPData));
    }
  } catch (error) {
    const basename = process.env.BASE_NAME;
    const message = {
      isOpen: true,
      mainHeader: "Failed to connect",
      subHeader: "",
      message: "Please check Network connection",
      subReq: false,
      callback: () => (window.location.href = `${basename}home`),
    };
    yield put(getNotificationMessage(message));
    yield put(setVerifyOTPAction.REJECTED(String(error)));
  }
}

function* changePassword(action: any): any {
  try {
    const changePasswordData = yield call(newRequest, {
      callType: "apollo",
      callMethod: "mutation",
      dataQuery: CHANGE_PASSWORD,
      data: action?.payload,
    });
    yield put(setChangePasswordAction.FULLFILLED(changePasswordData));
  } catch (error) {
    const basename = process.env.BASE_NAME;
    const message = {
      isOpen: true,
      mainHeader: "Failed to connect",
      subHeader: "",
      message: "Please check Network connection",
      subReq: false,
      callback: () => (window.location.href = `${basename}home`),
    };
    yield put(getNotificationMessage(message));
    yield put(setChangePasswordAction.REJECTED(String(error)));
  }
}

function* queryCountriesCode(): any {
  try {
    const COUNTRYData = yield call(newRequest, {
      callType: "apollo",
      callMethod: "query",
      dataQuery: COUNTRIES_CODE,
      clientType: "MO",
    });
    yield put(GqlCountriesCodeAction.FULLFILLED(COUNTRYData));
  } catch (error) {
    if (isGlobalApolloError(error)) return;
    const message = {
      isOpen: true,
      mainHeader: "Failed to connect",
      subHeader: "",
      message: "Please check Network connection",
      subReq: false,
    };
    yield put(getNotificationMessage(message));
    yield put(GqlCountriesCodeAction.REJECTED(String(error)));
  }
}

function* queryCitiesCode(action: any): any {
  try {
    const CITYData = yield call(newRequest, {
      callType: "apollo",
      callMethod: "query",
      dataQuery: STATES_CODE,
      clientType: "MO",
      data: action?.payload,
    });
    yield put(GqlCitiesCodeAction.FULLFILLED(CITYData));
  } catch (error) {
    if (isGlobalApolloError(error)) return;
    const message = {
      isOpen: true,
      mainHeader: "Failed to connect",
      subHeader: "",
      message: "Please check Network connection",
      subReq: false,
    };
    yield put(getNotificationMessage(message));
    yield put(GqlCitiesCodeAction.REJECTED(String(error)));
  }
}

function* queryCurrencyList(): any {
  try {
    const CurrencyData = yield call(newRequest, {
      callType: "apollo",
      callMethod: "query",
      dataQuery: CURRENCY_LIST,
      clientType: "MO",
    });
    yield put(GqlCurrencyListAction.FULLFILLED(CurrencyData));
  } catch (error) {
    if (isGlobalApolloError(error)) return;
    const message = {
      isOpen: true,
      mainHeader: "Failed to connect",
      subHeader: "",
      message: "Please check Network connection",
      subReq: false,
    };
    yield put(getNotificationMessage(message));
    yield put(GqlCurrencyListAction.REJECTED(String(error)));
  }
}

function* getGenerateAccessToken(action: any): any {
  try {
    const data = yield call(newRequest, {
      callType: "apollo",
      callMethod: "query",
      dataQuery: GENERATE_ACCESS_TOKEN_QUERY,
      clientType: "",
      data: {
        code: action?.payload?.code,
      },
    });

    if (data?.data?.generateAccessToken) {
      // action?.payload?.setLoader(false);
      yield put(
        generateAccessTokenAction.FULLFILLED({
          data: data?.data,
          status: 200,
        })
      );
    } else {
      const token = DOMPurify.sanitize(localStorage.getItem("token") as string);
      const wtoken = DOMPurify.sanitize(
        localStorage.getItem("wtoken") as string
      );
      // action?.payload?.setLoader(false);
      yield put(generateAccessTokenAction.REJECTED());
      if (token && wtoken) {
        setTimeout(function () {
          logout();
        }, 500);
      } else {
        window.location.href = "/";
      }
    }
  } catch (error: any) {
    const token = DOMPurify.sanitize(localStorage.getItem("token") as string);
    const wtoken = DOMPurify.sanitize(localStorage.getItem("wtoken") as string);
    // action?.payload?.setLoader(false);
    yield put(generateAccessTokenAction.REJECTED());
    if (token && wtoken) {
      setTimeout(function () {
        logout();
      }, 500);
    } else {
      window.location.href = "/";
    }
  }
}

export function* watcherLogin() {
  yield takeLatest(SET_GQL_AUTH_LOGIN.STARTED, setLoginGQL);
  yield takeLatest(SET_GQL_REFRESH_TOKEN.STARTED, setRefreshTokenGQL);
  yield takeLatest(
    SET_GQL_AGENT_CONTACT_DETAILS.STARTED,
    mutationAgentContactDetails
  );
  yield takeLatest(SET_GQL_GST_STATE_CODE.STARTED, queryGstStateCode);
  yield takeLatest(SET_GQL_COUNTRIES_CODE.STARTED, queryCountriesCode);
  yield takeLatest(SET_GQL_CITIES_CODE.STARTED, queryCitiesCode);
  yield takeLatest(SET_GQL_CURRENCY_LIST.STARTED, queryCurrencyList);
  yield takeLatest(SET_AUTH_FORGOTPASSWORD.STARTED, forgotPassword);
  yield takeLatest(SET_AUTH_RESETPASSWORD.STARTED, resetPassword);
  yield takeLatest(SET_AUTH_RESETPASSWORDLS.STARTED, resetPasswordLinkStatus);
  yield takeLatest(
    GENERATE_ACCESS_TOKEN_DETAILS.STARTED,
    getGenerateAccessToken
  );
  yield takeLatest(SET_AUTH_RESENDOTP.STARTED, resendOTP);
  yield takeLatest(SET_AUTH_VERIFYOTP.STARTED, verifyOTP);
  yield takeLatest(SET_AUTH_CHANGEPASSWORD.STARTED, changePassword);
}

export const sagas = [watcherLogin];
